import { gql } from '@apollo/client';

export const deleteListSettings = gql`
    query($id:Int, $typeId: Int) {
      deleteListSettings(id: $id, typeId: $typeId){
          status
          errorMessage
          }
        }
    `;

export const getAllAdminListSettings = gql`
    query ($currentPage: Int,$typeId: Int, $searchList: String) {
    	getAllAdminListSettings(currentPage: $currentPage,typeId: $typeId, searchList: $searchList){
        status
        errorMessage
        listSettingsTypeData {
          id
          typeName
          typeLabel
          fieldType
          isEnable
          step
        }
        count
        listSettingsData {
          id
          typeId
          itemName
          itemDescription
          otherItemName
          startValue
          endValue
          maximum
          minimum
          isEnable
          makeType
          dynamicItemName{
            id
            language
            itemName
            otherItemName
            itemDescription
          }
      	}
    	}  	
    }
    `;

export const getCarDetails = gql`
    query {
      getCarDetails{
            id
            typeName
          typeLabel
          fieldType
            isEnable
            step
          listSettings {
            id
            typeId
            itemName
            itemDescription
            otherItemName
            startValue
            endValue
            maximum
            minimum
            isEnable
            makeType
          }
          status
          }
        }
    `;